module.exports = __webpack_public_path__ + "img/marker_doanhnghiep1.0d3668e6.png";